import React from 'react'
import { string, bool, oneOf } from 'prop-types'

import classNames from 'classnames'

import { ICON_SIZE } from 'views/consts'

import { STAR_ICON_PATH } from './consts'

import './StarIcon.scss'

const StarIcon = ({ size, className, width, height, transparent, filled }) => {
  const iconClassName = classNames(
    'a-icon',
    `a-icon--${size} a-Star-Icon`,
    className,
    filled ? 'a-Star-Icon__filled' : 'a-Star-Icon__outline',
    transparent && 'a-Star-Icon--transparent'
  )

  return (
    <svg
      viewBox="0 0 100 100"
      width={width}
      height={height}
      className={iconClassName}
    >
      <path className="a-Star-Icon__bg" d={STAR_ICON_PATH.BG} />
      <path className="a-Star-Icon__stroke" d={STAR_ICON_PATH.STROKE} />
    </svg>
  )
}

StarIcon.propTypes = {
  width: string,
  height: string,
  size: oneOf(ICON_SIZE),
  className: string,
  transparent: bool,
  filled: bool
}

StarIcon.defaultProps = {
  width: '30',
  height: '30',
  size: 'default',
  className: null,
  transparent: false,
  filled: false
}

export default StarIcon
